import * as React from "react";
import { useState } from "react";
import { Field, withTypes } from "react-final-form";
import axios from "axios";

import {
    Button,
    CardActions,
    CircularProgress,
    TextField,
    Checkbox,
    FormControlLabel
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { Notification, useTranslate, useNotify } from "react-admin";
import { ENDPOINTS } from "../apiConstants";
import { getConfigPost } from "../getConfig";

const useStyles = makeStyles((theme) => ({
    main: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "flex-start",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
    },
    form: {
        padding: "0 1em 1em 1em",
        maxWidth: 400,
        width: "100%",
    },
    input: {
        marginTop: "1em",
    },
    actions: {
        padding: "1em 0",
    },
}));

const renderInput = ({
    meta: { touched, error } = { touched: false, error: undefined },
    input: { ...inputProps },
    ...props
}) => (
    <TextField
        error={!!(touched && error)}
        helperText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />
);

const renderCheckbox = ({ input, label }: any) => (
    <FormControlLabel control={<Checkbox {...input} checked={input.value} />} label={label} />
);

interface FormValues {
    code?: string;
    amount?: string;
    from_date?: string;
    to_date?: string;
    sws_introducer?: boolean;
    remortgage_introducer?: boolean;
    direct_debit_introducer?: boolean;
}

const { Form } = withTypes<FormValues>();

const CreatePromoCode = () => {
    const [loading, setLoading] = useState(false);
    const translate = useTranslate();
    const notify = useNotify();
    const classes = useStyles();

    const handleSubmit = async (data: FormValues) => {
        setLoading(true);

        const payload = {
            code: data.code,
            amount: data.amount,
            from_date: data.from_date,
            to_date: data.to_date,
            sws_introducer: String(data.sws_introducer),
            remortgage_introducer: String(data.remortgage_introducer),
            direct_debit_introducer: String(data.direct_debit_introducer),
        };

        try {
            const headers = getConfigPost();
            await axios.post(ENDPOINTS.CREATE_PROMOCODE, payload, { headers });
            notify("Promo code created successfully", "info");
        } catch (error) {
            notify((error as any)?.response?.data?.message || `Failed to create promo code`, "error", "", undefined, 50000);
        } finally {
            setLoading(false);
        }

    };

    const validate = (values: FormValues) => {
        const errors: FormValues = {};
        if (!values.code) errors.code = translate("ra.validation.required");
        if (!values.amount) errors.amount = translate("ra.validation.required");
        if (!values.from_date) errors.from_date = translate("ra.validation.required");
        return errors;
    };

    return (
        <Form
            onSubmit={handleSubmit}
            validate={validate}
            render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} noValidate>
                    <div className={classes.main}>
                        <div className={classes.form}>
                            <Field
                                name="code"
                                // @ts-ignore
                                component={renderInput}
                                label="Promo Code"
                                disabled={loading}
                            />
                            <Field
                                name="amount"
                                // @ts-ignore
                                component={renderInput}
                                label="Amount"
                                disabled={loading}
                            />
                            <Field
                                name="from_date"
                                // @ts-ignore
                                component={renderInput}
                                label="From Date"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                disabled={loading}
                            />
                            <Field
                                name="to_date"
                                // @ts-ignore
                                component={renderInput}
                                label="To Date"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                disabled={loading}
                            />
                            <Field
                                name="sws_introducer"
                                // @ts-ignore
                                component={renderCheckbox}
                                label="SWS Introducer"
                                type="checkbox"
                            />
                            <Field
                                name="remortgage_introducer"
                                // @ts-ignore
                                component={renderCheckbox}
                                label="Remortgage Introducer"
                                type="checkbox"
                            />
                            <Field
                                name="direct_debit_introducer"
                                // @ts-ignore
                                component={renderCheckbox}
                                label="Direct Debit Introducer"
                                type="checkbox"
                            />
                            <CardActions className={classes.actions}>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    fullWidth
                                    disabled={loading}
                                >
                                    {loading && <CircularProgress size={25} thickness={2} />}
                                    Create Promo Code
                                </Button>
                            </CardActions>
                            <Notification />
                        </div>
                    </div>
                </form>
            )}
        />
    );
};

export default CreatePromoCode;